// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const blockName = "ModuleWrapper2020__blockName__v91Kb";
export const bold = "700";
export const flexLayout = "ModuleWrapper2020__flexLayout__cVX7G";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "ModuleWrapper2020__header__oaCly";
export const headerInner = "ModuleWrapper2020__headerInner__4-OIf";
export const insights = "ModuleWrapper2020__insights__KAnHf";
export const medium = "500";
export const moduleWrapper = "ModuleWrapper2020__moduleWrapper__qx-wd";
export const noPadding = "ModuleWrapper2020__noPadding__HBdKR";
export const regular = "400";
export const rightArrow = "ModuleWrapper2020__rightArrow__U6B1e";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const subtitle = "ModuleWrapper2020__subtitle__0pceR";
export const title = "ModuleWrapper2020__title__84bKk";
export const tooltipIconWrapper = "ModuleWrapper2020__tooltipIconWrapper__Z58aJ TooltipIcon__tooltipIconWrapper__oUGNC";
export const withChevron = "ModuleWrapper2020__withChevron__4-toB";
export const withPaddingBottom = "ModuleWrapper2020__withPaddingBottom__uDDNc";